const URLs = {
  //HEADER URLS
  clientExt: 'V10',
  devExt: 'V10T',
  localExt: 'localhost',
  prodExt: 'feedbacksuite',

  //GET
  getUserSettings: '/settings/fetch_user_settings',
  getExerciseSettings: '/settings/fetch_exercise_settings',
  getScriptData: '/user/fetch_scripts',
  getExamList: '/protocols/fetch_exam',
  getExamByTrainingType: '/protocols/fetch_protocols',
  getLibraryData: '/library/fetch_library',
  getProtocolAllExams:'/protocols/fetch_all_exam',
  getExamExerciseRecord: '/protocols/fetch_exam_exercise',
  getSubscriberDetails:'/subscriber/subscribers_details',
  getSubscriptionPlans:'/subscription/active_plans',
  getStaffUserDetails:'/user/staff_user_details',
  logoutStaffUser:'/user/Logout_staff_user',
  getCountryList:'/geographical_location/fetch_geographical_locations',
  getUserTypes:'/subscriber/fetch_user_types',
  fetchAdminUsers: '/user/fetch_staff_users',
  getLatestSubscribers: '/subscriber_listing/latest_subscribers',
  getUsersCount: '/subscriber_listing/users_count',
  getTrainerByEmail: '/subscription/check_trainer_email',

  //PROMOTIONS
  validatePromoCode: '/promotions/validate',
  registerWithPromo: '/promotions/register',
  createManualSubscriber: '/promotions/create_manual_subscriber',
  managePromotions: '/promotions/manage',
  promoSubscribers: '/promotions/subscribers',

  //POST
  saveExamName: '/protocols/add_exam',
  saveExerciseAudio: '/protocols/upload_protocol_file',
  saveExerciseVideo: '/protocols/upload_protocol_video_file',
  saveBackgroundImage: '/settings/upload_bg_image',
  renameLibraryFile:'/library/rename_library',
  saveLibrayFile: '/library/add_library',
  saveNewUserData:'/subscriber/register_user',
  userLogin:'/subscriber/Login',
  userLogout:'/subscriber/subscribers_logout',
  forgotPassword:'/subscriber/reset-password-email',
  validateResetToken:'/subscriber/reset-password-email',
  resetPassword:'/subscriber/reset-password',
  getUserPermissions: '/subscriber/fetch_permissions',
  createCheckoutSession: '/create-checkout-session',
  createCheckoutPaymentLink:'/subscription/checkout_subscription',
  createCheckoutPayPalPaymentLink:'/subscription/create_payment',
  createCustomerPortal:'/subscription/create_customer_portal',
  getUserDetails: '/user/specific_staff_user_details',
  staffLogin:'/user/Login_staff_user',
  getSubscribers:'/subscriber_listing/subscriber_listing',
  exportSubscribers:'/subscriber_listing/export_subscribers',
  exportStaffUsers:'/user/export_staff_users',
  getArchivedusers:'/user/archive_staff_user',
  getSubscriberProfileDetails: '/subscriber_listing/subscriber_profile',
  getNotificationList: '/notifications/fetch_user_notifications',
  getNotificationCount: '/notifications/notification_count',
  getBackgroundImages: '/settings/fetch_bg_image',
  getFeatureUpgrade: '/subscriber/add-permissions',
  shareExam: '/protocols/share_exam',
  unshareExam: '/protocols/unshare_exam',
  getSharedExams: '/protocols/fetch_shared_exams',
  getExamShares: '/protocols/fetch_exam_shares',
  saveExerciseNote: '/protocols/save_exercise_note',
  downloadExamWavZip: '/protocols/download_exam_wav_zip',
  exportExerciseEvp: '/protocols/export_exercise_evp',
  importExerciseEvp: '/protocols/import_exercise_evp',
  resetExerciseFiles: '/protocols/reset_exercise_files',
  trimVideo: '/protocols/trim_protocol_video',
  saveTrimmedVideo: '/protocols/save_trimmed_video',
  uploadTempVideo: '/protocols/upload_temp_video',

  //EMAIL TEMPLATES
  emailTemplates: '/email_template/templates',
  sendEmail: '/email_template/send-email',

  //PUT
  updateUserSettings: '/settings/update_user_setting',
  updateExerciseSettings: '/settings/update_exercise_settings',
  updateScriptData: '/user/update_scripts',
  updateExerciseById: '/user/update_exercise',
  updateUserDetails:'/subscriber/edit_subscriber',
  updateUserPassword:'/subscriber/reset-profile-password',
  updateAdminProfile:'/user/update_staff_profile',
  updateAdminPassword:'/user/reset_staff_profile_password',
  markNotificationAsRead:'/notifications/notification_viewed',
  archiveSubscriber: '/subscriber/archive_subscriber',
  cancelSubscription: '/subscription/cancel_subscription',

  //DELETE
  deleteNotification: '/notifications/delete_notification',
  deleteExamById: '/protocols/delete_exam',
  deleteLibraryFile: '/library/delete_library',
  archiveAdminUser: '/user/archive_staff_user',
  deleteSubscriber: '/subscription/delete_subscriber',

  //COMMON
  saveAndUpdateAdminDetails:'/user/staff_user',

  //VOICE CONNECT (WebRTC signaling)
  voiceConnectInitiate: '/voice_connect/initiate',
  voiceConnectPending: '/voice_connect/pending',
  voiceConnectRespond: '/voice_connect/respond',
  voiceConnectSignal: '/voice_connect/signal',
  voiceConnectSignals: '/voice_connect/signals',
  voiceConnectEnd: '/voice_connect/end',
  voiceConnectTurnCredentials: '/voice_connect/turn_credentials'
}

export default URLs